import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import EPUndoRedoButtons from 'editor-components/header/EPUndoRedoButtons';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
// @ts-expect-error not yet migrated
import EditorConfigSingleton from 'ContentEditorUI/EditorConfigSingleton';
import { undoModuleReducerChange, redoModuleReducerChange
// @ts-expect-error not yet migrated
} from 'ContentEditorUI/redux/actions/undoRedoActions';
import { getCanRedoModules, getCanUndoModules } from 'ContentEditorUI/redux/selectors/moduleSelectors';
import { getIframeReady } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { selectCanUndoInstanceEditingState, selectCanRedoInstanceEditingState } from 'structured-content-lib/redux/selectors/instanceEditSelectors';
import { getIsDataAuthoringModeActive } from 'ContentEditorUI/redux/selectors/instanceEditingSelectors';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const canPerformUndoAction = createSelector([getCanUndoModules, selectCanUndoInstanceEditingState, getIsDataAuthoringModeActive], (canUndoModules, canUndoInstanceEditingState, isDataAuthoringModeActive) => {
  if (isDataAuthoringModeActive) {
    return canUndoInstanceEditingState;
  }
  return canUndoModules;
});
const canPerformRedoAction = createSelector([getCanRedoModules, selectCanRedoInstanceEditingState, getIsDataAuthoringModeActive], (canRedoModules, canRedoInstanceEditingState, isDataAuthoringModeActive) => {
  if (isDataAuthoringModeActive) {
    return canRedoInstanceEditingState;
  }
  return canRedoModules;
});
const UndoRedoButtonContainer = ({
  disabled,
  isVisible = true,
  tooltipPlacement
}) => {
  const dispatch = useDispatch();
  const canRedo = useSelector(canPerformRedoAction);
  const canUndo = useSelector(canPerformUndoAction);
  const iframeReady = useSelector(getIframeReady);
  const hasIframe = EditorConfigSingleton.getIsOnScalableEditor() ? EditorConfigSingleton.getHasIframe() : true;
  function handleRedo() {
    dispatch(redoModuleReducerChange());
  }
  function handleUndo() {
    dispatch(undoModuleReducerChange());
  }
  return /*#__PURE__*/_jsx(View, {
    display: isVisible ? 'block' : 'none',
    children: /*#__PURE__*/_jsx(EPUndoRedoButtons, {
      buttonUse: "tertiary-light",
      canRedo: canRedo,
      canUndo: canUndo,
      disabled: disabled || hasIframe && !iframeReady,
      onRedo: handleRedo,
      onUndo: handleUndo,
      tooltipPlacement: tooltipPlacement
      // Breaking for downstream components if we don't render yet if usageTracker
      // isn't ready yet. Should be handled correctly in the new trellis version
      // of the component.
      ,
      usageTracker: UsageTracker.getCachedClonedTracker('editorComponents')
    })
  });
};
export default UndoRedoButtonContainer;